import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy, OutlinedButton } from 'secondstep-components'
import ContinueButton from 'components/ContinueButton'

export const CancelButton = styled(OutlinedButton)`
  margin-right: 1rem;
  padding: 0.5625rem 0.938rem 0.375rem;
`

export const HelpCopy = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
  text-align: start;
  margin-top: -0.75rem;
  margin-bottom: -0.375rem;
  max-width: 48%;

  a {
    color: ${themeGet('colors.blue')};
  }
`

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const HelpAndButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const NextButton = styled(ContinueButton)`
  padding: 0.5625rem 0.938rem 0.375rem;
`

export const ErrorWrapper = styled.div`
  padding-top: 1.25rem;
  width: 100%;
`
